import { Pipe, PipeTransform } from '@angular/core';
import { DeficiencyTypes } from '@core/enums/deficiency-types';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'deficiencyTypeDisplayName',
  pure: false,
  standalone: true,
})
export class DeficiencyTypeDisplayNamePipe implements PipeTransform {
  public constructor(private translate: TranslateService) {}

  public transform(value: DeficiencyTypes | string): string {
    switch (value) {
      case DeficiencyTypes.UTAlarm: {
        return this.translate.instant('dashboard.UTAlarms');
      }
      case DeficiencyTypes.Redlining: {
        return this.translate.instant('dashboard.Redlining');
      }
      case DeficiencyTypes.Emergency: {
        return `${this.translate.instant('dashboard.P1')} - ${this.translate.instant('dashboard.Emergency')}`;
      }
      case DeficiencyTypes.High: {
        return `${this.translate.instant('dashboard.P2')} - ${this.translate.instant('dashboard.High')}`;
      }
      case DeficiencyTypes.Standard: {
        return `${this.translate.instant('dashboard.P3')} - ${this.translate.instant('dashboard.Standard')}`;
      }
      case DeficiencyTypes.Routine: {
        return `${this.translate.instant('dashboard.P4')} - ${this.translate.instant('dashboard.Routine')}`;
      }
      case DeficiencyTypes.Observation: {
        return `${this.translate.instant('dashboard.P5')} - ${this.translate.instant('dashboard.Observation')}`;
      }
    }
  }
}
